class EcoData extends HTMLElement {
    constructor() {
        super();

        const items = this.querySelectorAll("[data-grid]");
        items.forEach((item, index) => {
            item.addEventListener("click", () => {
                const isExpanded = item.classList.contains("eco-data__grid--expanded");
                items.forEach((e) => {
                    if (e.classList.contains("eco-data__grid--adjusted")) {
                        e.classList.remove("eco-data__grid--adjusted");
                    }
                })
                const element_position = index + 1;
                const isEven = (element_position % 2 === 0);
                const elementHeight = item.getBoundingClientRect().height;
                if (window.innerWidth < 1023) {
                    const get_odd_element = items[element_position];
                    const get_module = element_position / 2;
                    const get_top_index = get_module - 1;
                    const get_top_value = get_top_index * elementHeight;
                    if (isEven && get_odd_element) {
                        get_odd_element.classList.add("eco-data__grid--adjusted");
                        get_odd_element.style.top = `${get_top_value}px`;
                        get_odd_element.style.left = '50%';
                    }
                }
                else if (window.innerWidth < 1281 && window.innerWidth > 1023 ) { 
                    const element_position_3 = index + 1;
                    const isThird = (element_position % 3 === 0);

                    const elementHeight_3 = item.getBoundingClientRect().height;
                    const get_previous_element = items[element_position_3];
                    const get_module = element_position_3 / 3;
                    const get_top_index = get_module - 1;
                    const get_top_value = get_top_index * elementHeight_3;
                    if (isThird && get_previous_element) {
                        get_previous_element.classList.add("eco-data__grid--adjusted");
                        get_previous_element.style.top = `${get_top_value}px`;
                        get_previous_element.style.left = '66.666667%';
                    }
                }
                
                else if (window.innerWidth > 1280) {
                    const element_position_4 = index + 1;
                    const isFourth = (element_position % 4 === 0);

                    const elementHeight_4 = item.getBoundingClientRect().height;
                    const get_previous_element = items[element_position_4];
                    const get_module = element_position_4 / 4;
                    const get_top_index = get_module - 1;
                    const get_top_value = get_top_index * elementHeight_4;
                    if (isFourth && get_previous_element) {
                        get_previous_element.classList.add("eco-data__grid--adjusted");
                        get_previous_element.style.top = `${get_top_value}px`;
                        get_previous_element.style.left = '75%';
                    }
                }

                items.forEach((item_check) => {
                    if (item_check !== item) {
                        item_check.classList.remove("eco-data__grid--expanded");
                        item_check.classList.remove("eco-data__grid--blurred");
                        item_check.querySelector("[data-grid-item-right]").classList.remove("eco-data__grid-item-right--expanded");
                        const video = item_check.querySelector("[data-grid-item-left] [data-grid-item-left-video]");
                        if (video) {
                            video.pause();
                            video.currentTime = 0; // Reset video to initial time
                            video.load();
                        }
                    }
                });

                if (!isExpanded) {
                    item.classList.add("eco-data__grid--expanded");
                    item.classList.remove("eco-data__grid--blurred");
                    item.querySelector("[data-grid-item-right]").classList.add("eco-data__grid-item-right--expanded");

                    const video = item.querySelector("[data-grid-item-left] [data-grid-item-left-video]");
                    if (video) {
                        video.play();
                    }

                    items.forEach((item_check) => {
                        if (item_check !== item) {
                            item_check.classList.add("eco-data__grid--blurred");
                        }
                    });
                } else {
                    item.classList.remove("eco-data__grid--expanded");
                    item.querySelector("[data-grid-item-right]").classList.remove("eco-data__grid-item-right--expanded");
                    const video = item.querySelector("[data-grid-item-left] [data-grid-item-left-video]");
                    if (video) {
                        video.pause();
                        video.currentTime = 0; // Reset video to initial time
                        video.load();
                    }
                    items.forEach((item_check) => {
                        item_check.classList.remove("eco-data__grid--blurred");
                    });
                    items.forEach((e) => {
                        if (e.classList.contains("eco-data__grid--adjusted")) {
                            e.classList.remove("eco-data__grid--adjusted");
                        }
                    });
                }
            });
        });


        const get_filters = this.querySelectorAll("[data-filter-title]");
        const get_all_wrapper_divs = this.querySelectorAll("[data-eco-grid]");

        let materialFilteredItems = [];
        let recycleFilteredItems = [];

        if (!localStorage.getItem("material")) {
            localStorage.setItem("material", "View All");
        }
        if (!localStorage.getItem("recycle")) {
            localStorage.setItem("recycle", "View All");
        }

        function showAllItems() {
            get_all_wrapper_divs.forEach((item) => {
                item.classList.remove("hide");
            });
        }

        showAllItems();

        get_filters.forEach((get_filter) => {
            get_filter.addEventListener("click", () => {
                const get_hastext = get_filter.textContent;
                const get_text = get_hastext.replace("#", "").trim();
                console.log("get_text:", get_text);

                materialFilteredItems = [];
                recycleFilteredItems = [];

                get_all_wrapper_divs.forEach((item) => {
                    item.classList.remove("hide");
                });

                if (get_filter.classList.contains('material-filter')) {
                    get_filters.forEach(filter => {
                        if (filter.classList.contains('material-filter')) {
                            filter.classList.remove("active");
                        }
                    });
                    get_filter.classList.add("active");

                    localStorage.setItem("material", get_text);
                } else if (get_filter.classList.contains('recycle-filter')) {
                    get_filters.forEach(filter => {
                        if (filter.classList.contains('recycle-filter')) {
                            filter.classList.remove("active");
                        }
                    });
                    get_filter.classList.add("active");

                    localStorage.setItem("recycle", get_text);
                }

                const material = localStorage.getItem("material");
                const recycle = localStorage.getItem("recycle");

                console.log("material:", material, "recycle:", recycle);

                get_all_wrapper_divs.forEach((ele) => {
                    const getMaterial = ele.getAttribute("data-material");
                    const getRecyclability = ele.getAttribute("data-recyclability");

                    const getsplit_filters = getMaterial ? getMaterial.split(",").map(item => item.trim()) : [];
                    const getsplit_filters2 = getRecyclability ? getRecyclability.split(",").map(item => item.trim()) : [];

                    if (material === 'View All' || getsplit_filters.some(item => item === material)) {
                        materialFilteredItems.push(ele);
                    }

                    if (recycle === 'View All' || getsplit_filters2.some(item => item === recycle)) {
                        recycleFilteredItems.push(ele);
                    }
                });

                if (material === 'View All' && recycle !== 'View All') {
                    get_all_wrapper_divs.forEach((item) => {
                        if (!recycleFilteredItems.includes(item)) {
                            item.classList.add("hide");
                        }
                    });
                } else if (recycle === 'View All' && material !== 'View All') {
                    get_all_wrapper_divs.forEach((item) => {
                        if (!materialFilteredItems.includes(item)) {
                            item.classList.add("hide");
                        }
                    });
                } else if (material === 'View All' && recycle === 'View All') {
                    get_all_wrapper_divs.forEach((item) => {
                        item.classList.remove("hide");
                    });
                } else {
                    get_all_wrapper_divs.forEach((item) => {
                        if (!materialFilteredItems.includes(item) || !recycleFilteredItems.includes(item)) {
                            item.classList.add("hide");
                        }
                    });
                }

                console.log("Filtered Material Items:", materialFilteredItems);
                console.log("Filtered Recycle Items:", recycleFilteredItems);
            });
        });


        window.onload = () => {
            localStorage.setItem("material", "View All");
            localStorage.setItem("recycle", "View All");
            showAllItems();
        };
    }
}

customElements.define('eco-data', EcoData);